import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  // Checkbox,
  // FormControlLabel,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import DateRangeSelector from "../../../../../../Components/FormComponents/DateRangeSelector";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import SummaryLine from "./Components/summaryLine";
import AgentPerLine from "./Components/agentPerLine";
import QAAgentPerLine from "./Components/qaAgentPerLine";
import QAAgent from "./Components/qaAgent";
import Agent from "./Components/agent";
import withAuth from "../../../../../../Hoc/withAuth";

const QANew = ({ user }) => {
  const { token } = user;
  const { pathname } = useLocation();
  const [value, setValue] = React.useState([
    dayjs().startOf("month"),
    dayjs().endOf("month"),
  ]);
  // const [downloadExcel, setDownloadExcel] = React.useState(false);
  // const [includeTags, setIncludeTags] = React.useState(false);
  const [selectedPath, setSelectedPath] = React.useState(
    pathname.split("/")[3] || "",
  );
  const [reportTrigger, setReportTrigger] = React.useState(false);
  const [startDate, setStartDate] = React.useState(
    dayjs().startOf("month").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = React.useState(
    dayjs().endOf("month").format("YYYY-MM-DD"),
  );
  const [accordionExpanded, setAccordionExpanded] = React.useState(true);
  const [reportName, setReportName] = React.useState("");

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const Paths = [
    {
      name: "Inbound Line",
      location: "SummaryLine",
    },
    {
      name: "Agent per Inbound Line",
      location: "AgentPerLine",
    },
    {
      name: "Agent Overall",
      location: "Agent",
    },
    {
      name: "QA per Inbound Line",
      location: "QAAgentPerLine",
    },
    {
      name: "QA Overall",
      location: "QAAgent",
    },
  ];

  const handleChange = (event) => {
    const newPath = event.target.value;
    setSelectedPath(newPath);
    setReportName(Paths.find((path) => path.location === newPath)?.name || "");
    // navigate(newPath);
  };

  // const handleExcelChange = (event) => {
  //   setDownloadExcel(event.target.checked);
  // };
  // const handleTagChange = (event) => {
  //   setIncludeTags(event.target.checked);
  // };

  const handleRunReport = () => {
    // Format dates consistently
    const formattedStartDate = value[0].format("YYYY-MM-DD");
    const formattedEndDate = value[1].format("YYYY-MM-DD");

    // Collapse accordion
    setAccordionExpanded(false);

    // Handle detailed campaign separately since it's not using Outlet
    if (
      [
        "SummaryLine",
        "AgentPerLine",
        "Agent",
        "QAAgentPerLine",
        "QAAgent",
      ].includes(selectedPath)
    ) {
      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);
      setReportTrigger(true);
      setReportName(
        Paths.find((path) => path.location === selectedPath)?.name || "",
      );
    }

    console.log("Running report with:", {
      dateRange: {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      },
      // downloadExcel,
      currentPath: selectedPath,
    });
  };

  const reportComponents = {
    SummaryLine,
    AgentPerLine,
    Agent,
    QAAgentPerLine,
    QAAgent,
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Accordion
        expanded={accordionExpanded}
        onChange={() => setAccordionExpanded(!accordionExpanded)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="report-settings-content"
          id="report-settings-header"
        >
          <Typography variant="h6">Report Settings</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormControl fullWidth>
            <InputLabel>Select Report</InputLabel>
            <Select
              value={selectedPath}
              onChange={handleChange}
              label="Select Report"
            >
              {Paths.map((path, index) => (
                <MenuItem key={index} value={path.location}>
                  {path.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box sx={{ mt: 4 }}>
            <DateRangeSelector value={value} setValue={setValue} />
          </Box>
          <Box sx={{ mt: 4, display: "flex", alignItems: "center", gap: 2 }}>
            {/* <FormControlLabel
              control={
                <Checkbox
                  checked={downloadExcel}
                  onChange={handleExcelChange}
                  color="primary"
                  disabled={true}
                />
              }
              label="Download to Excel"
            /> */}
            {/* 
            Hide for now, will be added later
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeTags}
                  onChange={handleTagChange}
                  color="primary"
                  // disabled={true}
                />
              }
              label="Include Tags"
            /> */}
            <Button
              variant="contained"
              color="primary"
              onClick={handleRunReport}
            >
              Run Report
            </Button>
          </Box>
        </AccordionDetails>
      </Accordion>

      {
        // run report based on selectedPath
        reportTrigger && (
          <>
            <div>
              <h2>Report: {reportName} Inbound QA Report</h2>
              <p>
                {startDate} to {endDate}
              </p>

              {reportComponents[selectedPath] ? (
                React.createElement(reportComponents[selectedPath], {
                  startDate,
                  endDate,
                  token,
                })
              ) : (
                // <Outlet context={{ value, downloadExcel, selectedPath }} />
                <Outlet context={{ value, selectedPath }} />
              )}
            </div>
          </>
        )
      }
    </Box>
  );
};

export default withAuth(QANew);
